'use strict';

const entriesmap = require('./entries.js').default;

/*@ngInject*/
export function entryidServiceFactory() {

  return {
        getEntryID : function(entry) {
            return entriesmap[entry];
        }
  };

}

export default angular.module('mars.vet.services.entryid',[])
  .factory('EntryIDService', entryidServiceFactory)
  .name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/entryid/entryid.service.js